
import React, { memo } from 'react';
import { Bar } from 'react-chartjs-2';
import Typography from '@mui/material/Typography';
import {
  LineController,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement
} from 'chart.js';

import ChartJS from 'chart.js/auto';

ChartJS.register(
  LineController,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement
);


const ChartBar = (props) => {

  const { data } = props;
  const option = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: data?.legend,
        position: "bottom",

      },
      title: {
        display: true,
        text: data.unit,
        position: "left"
      },
      tooltip: {
        enabled: true,
        usePointStyle: true,
        callbacks: {
          title: (datas) => {
            return datas[0].dataset.label
          },
          label: (datas) => {
            let percentage = (data.percentage)?'%':'';
            let value = (datas.raw%1!==0)?Number(datas.raw).toFixed(2):datas.raw;
            return ` ${datas.label} ${value} ${percentage}`
          }
        },
      }
    },
   
  };
  
  return (
    <>
      <div className="title_chart">
        <Typography className="content-text" variant="h6" style={{fontSize:'1.15rem'}}>
        {data.title}
        </Typography>
        <Typography className="content-text" style={{fontSize:'0.9 rem'}}>
        {data.subTitle}
        </Typography>
      </div>


      <div className="body_chart">
        {
          data?.data &&
            <Bar data={data} options={option} aria-label={data.title || data.unit} />
        }
      </div>

    </>
  );
}

export default memo(ChartBar);
